export const LS_USER_TOKEN :string = 'user_token';
export const LS_ASIDE_NAV :string = 'nav_aside';